import React, { FC } from 'react';

interface Props {
  title: string;
  theme?: 'green' | 'orange';
  className?: string;
  containerClassName?: string;
}

export const PostCategoryTag: FC<Props> = ({ containerClassName, title, theme, className }) => {
  const getTheme = () => {
    switch (theme) {
      case 'orange':
        return { containerStyle: { backgroundColor: 'rgba(251, 234, 222, 1)' }, textClass: 'text-accent-orange' };
      default:
        return { containerStyle: { backgroundColor: 'rgba(208, 235, 235, 0.5)' }, textClass: 'text-ocean-blue' };
    }
  };

  const t = getTheme();

  return (
    <div className={`${containerClassName || ''} inline-flex`}>
      <div className={`px-4 py-2 rounded-full inline-flex ${className}`} style={t.containerStyle}>
        <span className={`font-opensans font-semibold text-sm leading-5 ${t.textClass}`}>{title}</span>
      </div>
    </div>
  );
};

export default PostCategoryTag;
